export default __webpack_public_path__ + "static/media/intercom.018b0e7f.svg";